import React from "react";
import { X } from "lucide-react";

const DialogComponent = ({
  open = false,
  onOpenChange,

  title = "Título del diálogo",
  description = "Descripción del diálogo",

  showAcceptButton = true,
  showCancelButton = false,
  acceptText = "Aceptar",
  cancelText = "Cancelar",

  onAccept,
  onCancel,

  acceptButtonStyle = {},
  cancelButtonStyle = {},
  isDesktop = false,

  isLoadingAccept = false,
  isLoadingCancel = false,

  disableAccept = false,
  disableCancel = false,

  disableBackdropClose = false,
  showCloseButton = true,
}) => {
  if (!open) return null;

  const handleClose = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleAccept = () => {
    if (onAccept) {
      onAccept();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      handleClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (disableBackdropClose) return;

    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(4px)",
      }}
      onClick={handleBackdropClick}
    >
      <div
        className="relative w-full max-w-md mx-4 animate-fadeIn"
        style={{
          backgroundColor: isDesktop ? "#1C1535" : "#2C2447",
          borderRadius: "24px",
          padding: "clamp(24px, 4vw, 32px)",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)",
        }}
      >
        {showCloseButton && (
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
            }}
            className="hover:bg-purple-900/20"
          >
            <X
              className="w-5 h-5"
              style={{
                color: "#BEBCC2",
              }}
            />
          </button>
        )}

        {/* Título */}
        <h2
          className="font-bold2"
          style={{
            fontSize: "clamp(20px, 4vw, 28px)",
            color: "#FAFAFA",
            marginBottom: "12px",
            paddingRight: "32px",
            lineHeight: "1.3",
          }}
        >
          {title}
        </h2>

        {/* Descripción */}
        <p
          style={{
            fontSize: "clamp(14px, 3vw, 16px)",
            color: "#BEBCC2",
            lineHeight: "1.5",
            marginBottom: "clamp(24px, 4vw, 32px)",
          }}
        >
          {description}
        </p>

        {/* Botones */}
        <div
          className="gap-3"
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {/* Botón Cancelar */}
          {showCancelButton && (
            <button
              onClick={handleCancel}
              disabled={disableCancel || isLoadingCancel}
              style={{
                flex: 1,
                height: "clamp(48px, 8vw, 56px)",
                borderRadius: "2rem",
                fontSize: "clamp(16px, 3.5vw, 18px)",
                fontWeight: "500",
                backgroundColor: "transparent",
                border: "2px solid #565584",
                color: "#C9B8FF",
                cursor:
                  disableCancel || isLoadingCancel ? "not-allowed" : "pointer",
                opacity: disableCancel || isLoadingCancel ? 0.5 : 1,
                transition: "all 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                ...cancelButtonStyle,
              }}
              className="hover:bg-purple-900/20"
            >
              {isLoadingCancel ? (
                <>
                  <div
                    className="border-2 border-current border-t-transparent rounded-full animate-spin"
                    style={{
                      width: "clamp(16px, 3vw, 20px)",
                      height: "clamp(16px, 3vw, 20px)",
                    }}
                  />
                  <span>Viajando...</span>
                </>
              ) : (
                cancelText
              )}
            </button>
          )}

          {/* Botón Aceptar */}
          {showAcceptButton && (
            <button
              onClick={handleAccept}
              disabled={disableAccept || isLoadingAccept}
              style={{
                flex: 1,
                height: "clamp(48px, 8vw, 56px)",
                borderRadius: "2rem",
                fontSize: "clamp(16px, 3.5vw, 18px)",
                fontWeight: "500",
                backgroundColor: "#7E02FC",
                border: "none",
                color: "#FFFFFF",
                cursor:
                  disableAccept || isLoadingAccept ? "not-allowed" : "pointer",
                opacity: disableAccept || isLoadingAccept ? 0.5 : 1,
                transition: "all 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                ...acceptButtonStyle,
              }}
              className="hover:bg-purple-900"
            >
              {isLoadingAccept ? (
                <>
                  <div
                    className="border-2 border-current border-t-transparent rounded-full animate-spin"
                    style={{
                      width: "clamp(16px, 3vw, 20px)",
                      height: "clamp(16px, 3vw, 20px)",
                    }}
                  />
                  <span>Viajando...</span>
                </>
              ) : (
                acceptText
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DialogComponent;
